import React, { useState } from 'react';
import { AppBar, Toolbar, IconButton, Typography, Box, Button, Container } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LogoutButton from './LogoutButton';
import logo from '../assets/images/logo.png';

const Menu = () => {

    const [toggleMenu, setToggleMenu] = useState(false);

    const handleMenuClick = () => {
        setToggleMenu(!toggleMenu);
    }

    const pages = [
        {
            name: "Inicio",
            target: "/"
        },
        {
            name: "El proyecto",
            target: "/about"
        },
        {
            name: "Datos",
            target: "/datos"
        },
        {
            name: "Cargar datos",
            target: "/form"
        },
        {
            name: "Recursos",
            target: "/ressources"
        },
        {
            name: "Contacto",
            target: "/contact"
        }
    ];

    const { isAuthenticated, logout } = useAuth();

    return (
        <AppBar position="sticky">
            <Toolbar variant="regular" sx={{ display: 'flex', flexDirection: 'column' }}>
                <Container sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', minHeight: 64 }}>
                    <Box sx={{ display: { xs: 'flex' }, alignItems: 'center', mr: 1 }} >
                        <Link to="/" style={{ marginTop: 8, marginBottom: 8, display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit' }}>
                            <img src={logo} alt="Lagos Abiertos" style={{ height: 48, width: 'auto' }} />
                            <Typography sx={{ display: 'flex', alignItems: 'center', ml: 1 }}>
                                Lagos Abiertos
                            </Typography>
                        </Link>
                    </Box>
                    <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none', justifyContent: 'end' } }}>
                        <IconButton edge="start" color="inherit" aria-label="menu" sx={{ mr: 2 }} onClick={handleMenuClick}>
                            <MenuIcon />
                        </IconButton>
                    </Box>
                    <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex', justifyContent: 'end' } }}>
                        {pages.map((page) => (
                            <Button
                                key={page.name}
                                component={Link}
                                to={page.target}
                                sx={{ my: 2, color: 'white', display: 'block', fontSize: '1.2rem' }}
                            >
                                {page.name}
                            </Button>
                        ))}
                        {isAuthenticated &&  <LogoutButton/>}
                    </Box>
                </Container>
                {toggleMenu && (
                    <Container sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            {pages.map((page) => (
                                <Button
                                    key={page.name}
                                    href={page.target}
                                    sx={{ color: 'white', display: 'flex', justifyContent: 'center', fontSize: '1.3rem' }}
                                >
                                    {page.name}
                                </Button>
                            ))}
                            {isAuthenticated &&  <LogoutButton/>}
                        </Box>
                    </Container>
                )}
            </Toolbar>
        </AppBar >
    );
}

export default Menu;